import { ContextService } from '../../../services/context_service';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { StructureService } from '../../../services/structure_service';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../../css/tabs.css';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface ZusatztoolsToolExcelImportVorschauProps extends React.ClassAttributes<any> {
    data: any;
    dataDb: any;
    dataIgnored?: any;
}

interface ZusatztoolsToolExcelImportVorschauState {
    data: any;
    tabIndex: number;
}

export class ZusatztoolsToolExcelImportVorschau extends
    React.Component<ZusatztoolsToolExcelImportVorschauProps, ZusatztoolsToolExcelImportVorschauState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            tabIndex: this.contextService.get('tabIdxZusatztoolsExcelImportVorschau')
                ? this.contextService.get('tabIdxZusatztoolsExcelImportVorschau')
                : 0
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(StructureService) private structureService: StructureService;

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.data !== prevProps.data) {
            this.init();
        }
    }

    init(): void {
        const data: any = {};

        Object.keys(this.props.data || {}).forEach((entity: any) => {
            const bundle: any = this.props.dataDb[`${entity}_bundle`] || {};
            const empty: any = {};
            const structure: any = this.structureService.getStructureByKey(IDs.MOD_ETOOL, entity);
            data[entity] = [];

            (structure.ATTS || []).forEach((att: any) => {
                empty[att.KEY || null] = null;
            });

            this.props.data[entity].forEach((row: any, index: number) => {
                data[entity].push({...empty, ...row});
                Object.keys(row).forEach((name: string) => {
                    if (bundle[name]) {
                        const value: any = data[entity][index][name];
                        const valueString: string = (bundle[name].find((field: any) => field.tid == value) || {}).name;

                        if (value && valueString) {
                            data[entity][index][`${name}_orig`] = value;
                            data[entity][index][name] = valueString;
                        }
                    }
                });
            });
        });
        this.setState({ data });
    }

    render(): JSX.Element {
        if (!this.state.data || !this.props.dataDb) {
            return <div>Lade...</div>;
        }
        const data: any = this.state.data || {};
        const keys: Array<any> = Object.keys(data);

        return (
            <div>
                <Tabs
                    className={'tabs-zusatztools'}
                    selectedIndex={this.state.tabIndex}
                    onSelect={
                        (tabIndex, lastIndex, event) => this.setState(
                            {tabIndex},
                            () => this.contextService.set('tabIdxZusatztoolsExcelImportVorschau', this.state.tabIndex))
                    }
                >
                    <TabList>
                        {keys.map((entity: string, index: number) => {
                            const struct = this.structureService.getStructureByKey(IDs.MOD_ETOOL, entity);
                            return (
                                <Tab key={`tab-${index}`}>
                                    {struct ? struct.TITEL : entity}
                                </Tab>
                            );
                        })}
                    </TabList>
                    {keys.map((entity: string, index: number) =>
                        <TabPanel key={`panel-${index}`}>
                            {this.renderTable(entity, data[entity] || [])}
                        </TabPanel>
                    )}
                </Tabs>
            </div>
        );
    }

    renderHinweis(entity: string): JSX.Element {
        const dataIgnored: any = this.props.dataIgnored || {};
        const data: Array<any> = dataIgnored[entity] || [];
        const style: React.CSSProperties = { fontSize: '9pt', fontWeight: 'bold', color: 'red', margin: '4px 0' };

        if (data.length) {
            const jahre: Array<any> = Array.from(new Set(data.map((row: any) => row.jahr)));

            return (
                <div style={style}>
                    ACHTUNG: Es wurden für die Jahre [{jahre.join(', ')}] {data.length} Datensätze ignoriert, da bereits
                    Datensätze für diese Jahre in der Datenbank existieren.
                </div>
            );
        }

        return null;
    }

    renderTable(entity: string, data: Array<any>): JSX.Element {
        const bundle: any = this.props.dataDb[`${entity}_bundle`] || {};
        // console.log('IMP-Data', entity, data);

        return (
            <>
                {this.renderHinweis(entity)}
                <WFormsTableWrapper
                    entity={entity}
                    module={IDs.MOD_ETOOL}
                    data={data}
                    bundle={bundle}
                    hiddenColumns={['standort_tid']}
                    actions={[]}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                />
            </>
        );
    }
}
